import React, { forwardRef, MouseEvent, Ref } from 'react';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import { down } from 'styled-breakpoints';
import Button from '@fenderdigital/ui/Button';
import { Expand, XThin } from '@fenderdigital/ui/Icons';
import * as S from './FullScreenButton-styled';

interface FullScreenButtonProps {
  ariaLabel?: string;
  label?: string;
  handleClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
  icon?: string;
  ref?: Ref<HTMLButtonElement>;
}

const FullScreenButton: React.FC<FullScreenButtonProps> = forwardRef(
  (
    { ariaLabel = 'Full Screen', label = 'Full Screen', handleClick, icon = 'icon-expand' },
    ref,
  ) => {
    const isSmallPhone = !!useBreakpoint(down('phone'));

    return (
      <S.FullScreenButtonContainer isSmallPhone={isSmallPhone}>
        <Button
          ref={ref}
          dataId="expand-button"
          ariaLabel={ariaLabel}
          variant="outline"
          size="small"
          colorScheme="lightGray"
          textColor="darkGray"
          leftIcon={
            icon === 'icon-expand' ? <Expand css={S.StyledIcon} /> : <XThin css={S.StyledIcon} />
          }
          onClick={handleClick}
        >
          {!isSmallPhone && label}
        </Button>
      </S.FullScreenButtonContainer>
    );
  },
);

export default FullScreenButton;
